export const calculateChecksum = (fileData: Uint8Array) => {
  let checksum = 0;
  for (let i = 0; i < fileData.length; i++) {
    checksum += fileData[i];
  }
  return checksum;
};
